(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["av-blog-slider"] && !Shopify.designMode) return;
  try {
    
 /*------------------- av blog slider js start ----------------------*/
$(document).ready(function () {
  const glowSwiper = new Swiper('.av-blog-slider', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
     breakpoints: {
      576: { slidesPerView: 1, spaceBetween: 20, },
      768: { slidesPerView: 1, spaceBetween: 20,},
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
   pagination: {
      el: ".swiper-pagination",
      clickable: true,
      type: "bullets",
    },

  });
});
 /*------------------- av blog slider js end ----------------------*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hanbang-match-slider"] && !Shopify.designMode) return;
  try {
    

function initHanbangSwiper() {
document.querySelectorAll('.hanbang-match-swiper')
.forEach((slider)=>{
                        if(slider.classList.contains('swiper-initialized')){
                        return;
                    }
const totalSlides=slider.querySelectorAll('.swiper-slide').length;
function getSlidesPerView(){const width=window.innerWidth;
                    if(width>=1024)
                        return 5;
                        if(width>=768)
                        return 3;
                        return 2;       
                    }

function updateControls(){
    const enable=totalSlides>getSlidesPerView();
    const nextBtn=slider.querySelector('.swiper-button-next');
    const prevBtn=slider.querySelector('.swiper-button-prev');
    const pagination=slider.querySelector('.swiper-pagination');
    if(nextBtn){nextBtn.style.display=enable?'flex':'none';}
    if(prevBtn){prevBtn.style.display=enable?'flex':'none';}
    if(pagination){pagination.style.display=enable?'block':'none';}
}

new Swiper(slider,{loop:totalSlides>getSlidesPerView(),
    speed:800,
    grabCursor:true,
    observer:true,
    observeParents:true,
    watchOverflow:true,
    autoplay:
    totalSlides> getSlidesPerView()?{
    delay:4000,
    disableOnInteraction:false,
    pauseOnMouseEnter:true
}:false,
    slidesPerView:2,
    spaceBetween:10,
    breakpoints:{
    768:{
        slidesPerView:3,
        spaceBetween:15
    },
    1024:{
        slidesPerView:5,
        spaceBetween:20
    }
},
    navigation:{
                nextEl:slider.querySelector('.swiper-button-next'),
                prevEl:slider.querySelector('.swiper-button-prev')},
                pagination:{el:slider.querySelector('.swiper-pagination'),
                clickable:true},
                on:{init(){updateControls();},
                resize(){updateControls();}
                }
            });
        });
    }
document.addEventListener('DOMContentLoaded',initHanbangSwiper);
document.addEventListener('shopify:section:load', initHanbangSwiper);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-content-section"] && !Shopify.designMode) return;
  try {
    


window.addEventListener('load', function () {
    AOS.refresh();
});

document.addEventListener('shopify:section:load', function () {
    AOS.refreshHard();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["insta-video-slider"] && !Shopify.designMode) return;
  try {
    

/*------------  instagram video  swiper slider js start -----------------*/
// Prevent non-visible videos from downloading immediately
document.querySelectorAll(".mijoo-insta-videos").forEach(video => {
    video.preload = "none";
});

document.addEventListener("DOMContentLoaded", function () {
  const swiper = new Swiper(".instagram-video-slider", {
    slidesPerView: 7.5,
    centeredSlides: true,
    spaceBetween: 15,
    loop: true,
    speed: 600,
    autoplay: {
      delay: 50000,
      disableOnInteraction: false,
    },
    breakpoints: {
      0: { slidesPerView: 1.3 },
      768: { slidesPerView: 2.5 },
      1024: { slidesPerView: 3.1 },
      1200: { slidesPerView: 4.1 },
      1400: { slidesPerView: 4.5 },
      1800: { slidesPerView: 6.1 }
    },
    on: {
      init(sw) {
        playActive(sw);
      },
      slideChange(sw) {
        pauseAll(sw);
        setTimeout(() => playActive(sw), 20);
      },
      transitionEnd(sw) {
        playActive(sw);
      }
    }
  });
  swiper.on("click", function (sw, e) {
    if (e.target.closest('.vw-stop-button-shoppable') ||
        e.target.closest('.vw-mute-button-shoppable')) return;
    if (sw.clickedSlide) {
      const idx = sw.clickedSlide.dataset.swiperSlideIndex;
      sw.slideToLoop(idx, 600);
    }
  });
  function pauseAll(sw) {
    sw.slides.forEach(slide => {
      const v = slide.querySelector("video");
      if (v) v.pause();
    });
  }
  function playActive(sw) {
    const real = sw.realIndex;
    sw.slides.forEach(slide => {
      const v = slide.querySelector("video");
      if (!v) return;
      const idx = Number(slide.dataset.swiperSlideIndex);
      const isActive = idx === real;
      const userPaused = v.dataset.userPaused === "true";
      if (isActive) {
        if (!userPaused) {
            if (v.preload === "none") {
              v.preload = "metadata";
              v.load();
            }
          v.play().catch(() => {});
          setIcon(slide, true);
        }
      } else {
        v.pause();
        v.currentTime = 0;
        v.dataset.userPaused = "false"; 
        setIcon(slide, false);
      }
    });
  }
  document.querySelectorAll(".vw-stop-button-shoppable").forEach(btn => {
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      const slide = this.closest(".swiper-slide");
      const v = slide.querySelector("video");
      if (!v) return;
      if (v.paused) {
        v.dataset.userPaused = "false";
        v.play().catch(() => {});
        setIcon(slide, true);
      } else {
        v.dataset.userPaused = "true";
        v.pause();
        setIcon(slide, false);
      }
    });
  });
  document.querySelectorAll(".vw-mute-button-shoppable").forEach(btn => {
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      const v = this.closest(".insta-video-box").querySelector("video");
      v.muted = !v.muted;
      this.querySelector(".icon-mute").style.display = v.muted ? "block" : "none";
      this.querySelector(".icon-unmute").style.display = v.muted ? "none" : "block";
    });
  });
  function setIcon(slide, playing) {
    const btn = slide.querySelector(".vw-stop-button-shoppable");
    if (!btn) return;
    btn.querySelector(".icon-play").style.display  = playing ? "none" : "block";
    btn.querySelector(".icon-pause").style.display = playing ? "block" : "none";
  }
});
/*------------  instagram video  swiper slider js end -----------------*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-posts-slider"] && !Shopify.designMode) return;
  try {
    
/*------------  instagram-post-container swiper slider js start -----------------*/
document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".instagram-post-container");
  if (!slider) return;
  const totalSlides = slider.querySelectorAll(".swiper-slide").length;
  function getSlidesPerView() {
    const width = window.innerWidth;
    if (width >= 1024) return 6;   
    if (width >= 768) return 3;    
    return 2;                      
  }
  function shouldEnableControls() {
    const slidesPerView = getSlidesPerView();
    return totalSlides > slidesPerView;
  }
  const swiper = new Swiper(".instagram-post-container", {
    loop: totalSlides > 2,
    speed: 800,
    grabCursor: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    slidesPerView: 2,
    spaceBetween: 10,
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 6,
        spaceBetween: 20
      }
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    on: {
      init: function () {
        updateControls();
      },
      resize: function () {
        updateControls();
      }
    }
  });
  function updateControls() {
    const enable = shouldEnableControls();
    const nextBtn = slider.querySelector(".swiper-button-next");
    const prevBtn = slider.querySelector(".swiper-button-prev");
    const paginationEl = slider.querySelector(".swiper-pagination");
    if (nextBtn) nextBtn.style.display = enable ? "flex" : "none";
    if (prevBtn) prevBtn.style.display = enable ? "flex" : "none";
    if (paginationEl) paginationEl.style.display = enable ? "block" : "none";
  }
});
/*------------  instagram-post-container slider js end -----------------*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mid-banner"] && !Shopify.designMode) return;
  try {
    

window.addEventListener('load', function () {
    AOS.refresh();
});

document.addEventListener('shopify:section:load', function () {
    AOS.refreshHard();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swiper-image-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".mijooherobanner-full", {
    loop: true,
    speed: 1200,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
});

  } catch(e) { console.error(e); }
})();
})();
